(function (window, document) {
  'use strict';

  var CS_CONFIG = {
    storageKey: 'cs_alia_customer_data',
    defaultSource: 'guest',
    aliaSource: 'alia_fallback',
    aliaSignupSource: 'alia_signup',
    eventName: 'cs_score',
    identifiedEventName: 'cs_customer_identified',
    debug: false
  };

  function logDebug() {
    if (!CS_CONFIG.debug || !window.console) return;
    try {
      console.log.apply(console, arguments);
    } catch (e) {}
  }

  function safeJsonParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function safeLocalStorageGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      if (!window.localStorage) return false;
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function normalizeEmail(email) {
    if (!email) return null;

    var normalized = String(email).trim().toLowerCase();

    // Basic email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
      return null;
    }

    return normalized;
  }

  function normalizePhone(phone) {
    if (!phone) return null;

    var normalized = String(phone).replace(/[^\d+]/g, '');

    // If phone starts with +, keep it. Otherwise remove non-digits only.
    if (normalized.charAt(0) === '+') {
      normalized = '+' + normalized.substring(1).replace(/\D/g, '');
    } else {
      normalized = normalized.replace(/\D/g, '');
    }

    // Avoid saving invalid/too short phone values
    if (normalized.replace(/\D/g, '').length < 7) {
      return null;
    }

    return normalized;
  }

  function cleanText(value) {
    if (value === null || value === undefined) return null;
    var cleaned = String(value).trim();
    return cleaned || null;
  }

  function getDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function pushDataLayer(payload) {
    try {
      if (!payload || typeof payload !== 'object') return false;

      getDataLayer().push(payload);

      logDebug('[CS Tracking] dataLayer pushed:', payload);
      return true;
    } catch (e) {
      logDebug('[CS Tracking] dataLayer push failed:', e);
      return false;
    }
  }

  function getStoredAliaCustomerData() {
    var rawData = safeLocalStorageGet(CS_CONFIG.storageKey);
    var parsedData = safeJsonParse(rawData || '{}', {});

    return {
      email: normalizeEmail(parsedData.email),
      phone: normalizePhone(parsedData.phone),
      source: cleanText(parsedData.source) || CS_CONFIG.aliaSource,
      saved_at: cleanText(parsedData.saved_at)
    };
  }

  function saveStoredAliaCustomerData(data) {
    if (!data || (!data.email && !data.phone)) return false;

    var payload = {
      email: normalizeEmail(data.email),
      phone: normalizePhone(data.phone),
      source: cleanText(data.source) || CS_CONFIG.aliaSignupSource,
      saved_at: cleanText(data.saved_at) || new Date().toISOString()
    };

    if (!payload.email && !payload.phone) return false;

    safeLocalStorageSet(CS_CONFIG.storageKey, JSON.stringify(payload));
    setCSCustomerData(payload);

    return true;
  }

  function setCSCustomerData(data) {
    if (!data || (!data.email && !data.phone)) return;

    window.CSCustomerData = {
      email: normalizeEmail(data.email),
      phone: normalizePhone(data.phone),
      source: cleanText(data.source) || CS_CONFIG.aliaSource,
      saved_at: cleanText(data.saved_at) || null
    };
  }

  function getShopifyCustomerData() {
    var customer = null;

    try {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.customer
      ) {
        customer = window.ShopifyAnalytics.meta.customer;
      }
    } catch (e) {
      customer = null;
    }

    if (!customer) {
      return {
        customerName: null,
        customerEmail: null,
        customerPhone: null,
        customerSource: CS_CONFIG.defaultSource
      };
    }

    var firstName = cleanText(customer.firstName);
    var lastName = cleanText(customer.lastName);
    var fullName = cleanText(customer.name);

    if (!fullName && (firstName || lastName)) {
      fullName = [firstName, lastName].filter(Boolean).join(' ');
    }

    var email = normalizeEmail(customer.email);
    var phone = normalizePhone(customer.phone);

    return {
      customerName: fullName,
      customerEmail: email,
      customerPhone: phone,
      customerSource: email || phone || fullName ? 'shopify' : CS_CONFIG.defaultSource
    };
  }

  function getCustomerData(manualData) {
    manualData = manualData || {};

    var shopifyData = getShopifyCustomerData();
    var aliaData = window.CSCustomerData || getStoredAliaCustomerData();

    var manualEmail = normalizeEmail(
      manualData.email ||
      manualData.customer_email ||
      manualData.customerEmail
    );

    var manualPhone = normalizePhone(
      manualData.phone ||
      manualData.customer_phone ||
      manualData.customerPhone
    );

    var manualName = cleanText(
      manualData.name ||
      manualData.customer_name ||
      manualData.customerName
    );

    var finalName =
      manualName ||
      shopifyData.customerName ||
      null;

    var finalEmail =
      manualEmail ||
      shopifyData.customerEmail ||
      normalizeEmail(aliaData.email) ||
      null;

    var finalPhone =
      manualPhone ||
      shopifyData.customerPhone ||
      normalizePhone(aliaData.phone) ||
      null;

    var finalSource = CS_CONFIG.defaultSource;

    if (manualEmail || manualPhone || manualName) {
      finalSource = 'manual';
    } else if (shopifyData.customerSource === 'shopify') {
      finalSource = 'shopify';
    } else if (aliaData && (aliaData.email || aliaData.phone)) {
      finalSource = aliaData.source || CS_CONFIG.aliaSource;
    }

    return {
      customerName: finalName,
      customerEmail: finalEmail,
      customerPhone: finalPhone,
      customerSource: finalSource
    };
  }

  function buildUserData(customerData) {
    return {
      email: customerData.customerEmail || null,
      phone_number: customerData.customerPhone || null
    };
  }

  function removePrivateOverrideKeys(extraData) {
    var cleaned = {};

    if (!extraData || typeof extraData !== 'object') {
      return cleaned;
    }

    Object.keys(extraData).forEach(function (key) {
      // These fields are handled centrally to avoid wrong overwrite
      if (
        key === 'email' ||
        key === 'phone' ||
        key === 'name' ||
        key === 'customerEmail' ||
        key === 'customerPhone' ||
        key === 'customerName' ||
        key === 'customer_email' ||
        key === 'customer_phone' ||
        key === 'customer_name' ||
        key === 'customer_source' ||
        key === 'user_data'
      ) {
        return;
      }

      cleaned[key] = extraData[key];
    });

    return cleaned;
  }

  function trackEvent(eventType, extraData) {
    try {
      eventType = cleanText(eventType);

      if (!eventType) {
        logDebug('[CS Tracking] Missing eventType');
        return false;
      }

      extraData = extraData && typeof extraData === 'object' ? extraData : {};

      var customerData = getCustomerData(extraData);
      var safeExtraData = removePrivateOverrideKeys(extraData);

      var payload = Object.assign({}, safeExtraData, {
        event: CS_CONFIG.eventName,
        eventType: eventType,

        customer_name: customerData.customerName || null,
        customer_email: customerData.customerEmail || null,
        customer_phone: customerData.customerPhone || null,
        customer_source: customerData.customerSource || CS_CONFIG.defaultSource,

        user_data: buildUserData(customerData),

        cs_timestamp: new Date().toISOString()
      });

      return pushDataLayer(payload);
    } catch (e) {
      logDebug('[CS Tracking] trackEvent failed:', e);
      return false;
    }
  }

  function identifyCustomer(data) {
    try {
      data = data || {};

      var email = normalizeEmail(data.email || data.customer_email);
      var phone = normalizePhone(data.phone || data.customer_phone);

      if (!email && !phone) return false;

      var customerData = {
        email: email,
        phone: phone,
        source: cleanText(data.source) || 'manual_identify',
        saved_at: new Date().toISOString()
      };

      saveStoredAliaCustomerData(customerData);

      pushDataLayer({
        event: CS_CONFIG.identifiedEventName,
        eventType: customerData.source,
        customer_email: customerData.email || null,
        customer_phone: customerData.phone || null,
        customer_source: customerData.source,
        user_data: {
          email: customerData.email || null,
          phone_number: customerData.phone || null
        },
        cs_timestamp: customerData.saved_at
      });

      return true;
    } catch (e) {
      logDebug('[CS Tracking] identifyCustomer failed:', e);
      return false;
    }
  }

  function handleAliaSignup(event) {
    try {
      var detail = event && event.detail ? event.detail : {};

      var email = normalizeEmail(detail.email);
      var phone = normalizePhone(detail.phone);

      if (!email && !phone) return;

      identifyCustomer({
        email: email,
        phone: phone,
        source: CS_CONFIG.aliaSignupSource
      });
    } catch (e) {
      logDebug('[CS Tracking] Alia signup handler failed:', e);
    }
  }

  function init() {
    try {
      // Load stored Alia/customer fallback data immediately
      setCSCustomerData(getStoredAliaCustomerData());

      // Listen for Alia signup event
      document.addEventListener('alia:signup', handleAliaSignup, false);

      // Expose public methods
      window.csTrackEvent = trackEvent;
      window.csIdentifyCustomer = identifyCustomer;
      window.csGetCustomerData = getCustomerData;

      logDebug('[CS Tracking] initialized');
    } catch (e) {
      logDebug('[CS Tracking] init failed:', e);
    }
  }

  init();

})(window, document);